"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

// Watches the given section ids and returns whichever is currently crossing
// the upper-middle of the viewport. Optionally keeps the URL hash in sync.
export const useScrollSpy = (ids, t0) => {
  const $ = _c(4);
  const syncUrl = t0 === undefined ? false : t0;
  const [active, setActive] = useState(null);
  let t1;
  let t2;
  if ($[0] !== ids || $[1] !== syncUrl) {
    t1 = () => {
      const sections = ids.map(_temp).filter(_temp2);
      if (!sections.length) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        const top = entries.filter(_temp3).sort(_temp4)[0];
        if (!top) {
          return;
        }
        const id_0 = top.target.id;
        setActive(id_0);
        if (syncUrl) {
          const url = id_0 === "home" ? window.location.pathname : `#${id_0}`;
          history.replaceState(null, "", url);
        }
      }, {
        rootMargin: "-40% 0px -55% 0px",
        threshold: [0, 0.5, 1]
      });
      sections.forEach(s => observer.observe(s));
      const onScroll = () => {
        if (window.scrollY > 80) {
          return;
        }
        setActive(null);
        if (syncUrl) {
          history.replaceState(null, "", window.location.pathname);
        }
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      onScroll();
      return () => {
        observer.disconnect();
        window.removeEventListener("scroll", onScroll);
      };
    };
    t2 = [ids, syncUrl];
    $[0] = ids;
    $[1] = syncUrl;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return active;
};
function _temp(id) {
  return document.getElementById(id);
}
function _temp2(el) {
  return el !== null;
}
function _temp3(e) {
  return e.isIntersecting;
}
function _temp4(a, b) {
  return b.intersectionRatio - a.intersectionRatio;
}